module.exports = __webpack_public_path__ + "static/media/choithramsRecipeTwo.4442b09d.png";